import EduContentCourseContainer from "modules/ReviewEducationalContent/containers/EduContentCourseContainer"

type Props = {}

const EducationContentCourse = (props: Props) => {
    return (
        <EduContentCourseContainer />
    )
}

export default EducationContentCourse